module.exports = __webpack_public_path__ + "img/KinokoTable41.edc5e191.jpg";